import React from "react";

const Step = ({
  stepId,
  title,
  description,
  imageSrc,
  activeTab,
  handleTabClick,
}) => {
  return (
    <li
      className={`fiu-process-links ${activeTab === stepId ? "active" : ""}`}
      onClick={() => handleTabClick(stepId)}
    >
      <div className="fiu-left-content-wrap">
        <span
          className={`fiu-left-content-title text-nowrap ${
            activeTab === stepId ? "active" : ""
          }`}
        >
          {title}
        </span>
        <div className="fiu-left-content-flex">
          <h6
            className={`fiu-left-content-title ${
              activeTab === stepId ? "active" : ""
            }`}
          >
            {description}
          </h6>
          <span
            className={`fiu-process-arrow ${
              activeTab === stepId ? "active" : ""
            }`}
          >
            <i className="fa-solid fa-angle-right"></i>
          </span>
        </div>
      </div>
    </li>
  );
};

export default Step;
